'use strict'

/**
 * Фильтрация Типов заявок по доступу
 */
export function filterRequestTypesByUserAccess (requestTypes, user, currentRequestTypeId) {
  // const user = this.$store.getters.getUser
  const externalDispatcherBounded = user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')

  let userAvailableRequestTypesIds = null
  if (externalDispatcherBounded) {
    if (user.employee && user.employee.availableRequestTypes) {
      userAvailableRequestTypesIds = new Set(user.employee.availableRequestTypes.map(requestType => requestType.id))
    }
  }
  if (userAvailableRequestTypesIds) {
    const filteredRequestTypes = []
    for (const requestType of requestTypes) {
      if ((requestType.id === currentRequestTypeId) || userAvailableRequestTypesIds.has(requestType.id)) {
        filteredRequestTypes.push(requestType)
      }
    }
    requestTypes = filteredRequestTypes
  }
  return requestTypes
}

/**
 * Фильтрация Типов заявок по Типу объекта обслуживания
 */
export function filterRequestTypesByServiceObjectType (requestTypes, currentServiceObjectTypeKey, currentRequestTypeId) {
  if (currentServiceObjectTypeKey) {
    const filteredRequestTypes = []
    for (const requestType of requestTypes) {
      const serviceObjectTypes = requestType.serviceObjectType
      if ((requestType.id === currentRequestTypeId) || //
            (!requestType.isAudit && !requestType.notMatchWorkArea && serviceObjectTypes && serviceObjectTypes.find(type => type.key === currentServiceObjectTypeKey)) //
      ) {
        filteredRequestTypes.push(requestType)
      }
    }
    requestTypes = filteredRequestTypes
  }
  return requestTypes
}
